import { render, staticRenderFns } from "./ModeloSelect.vue?vue&type=template&id=a5be5caa"
import script from "./ModeloSelect.vue?vue&type=script&lang=js"
export * from "./ModeloSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports